import React, { useEffect, useState } from 'react'
import { Field, Form, Formik } from "formik";
import { Link } from 'react-router-dom'
import Select from "react-select"
import * as Yup from "yup";
// import { toastError, toastSuccess } from "../../../common/Toast";
import Loader from '../../../../components/Loader/Loader';
import Sidebar from '../../../Dashboard/Sidebar/Sidebar';
import config from '../../../../config/config';
import { toastError, toastSuccess } from '../../../../common/Toast';
import Moment from "moment";
import {CUSTOM_SELECT_DROPDOWN_STYLE} from "../../../../common/Constant";

const ManageTask = () => {
  const [loading, setLoading] = useState(false);
  const [option, setOption] = useState()
  const [recurring, setRecurring] = useState(false)
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [weekOfMonth, setWeekOfMonth] = useState(
    {
      label: "",
      value: 0
    }
  )
  const [daysOfMonth, setDaysOfMonth] = useState(
    {
      label: Moment().format('dddd'),
      value: 0
    }
  )
  const [selectedDate, setSelectedDate] = useState('');
  const [selectYearDate,setSelectYearDate] = useState('')
  const [repeatEvery, setRepeatEvery] = useState()
  const [selectedDay, setSelectedDay] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState()

  const [todayDay, setTodayDay] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [todayDate, setTodayDate] = useState(
    Moment().format('YYYY-MM-DD')
  );

  console.log(todayDate, "todayDate23324")

  // const [formValues, setFormValues] = useState({
  //   GiftcardNumber: "",
  //   Description: "",
  //   Value: "",
  //   CustomerName: "",
  //   Inactive: false,
  // });

  //Day to Day mapping of entire calendar

  const monthsList = Moment.months();
  const monthsDropdown = monthsList?.map((el, index) => {
    let obj = {};
    obj["label"] = el;
    obj["value"] = index + 1;
    return obj
  })

  console.log(monthsDropdown, "monthsDropdown")
  // console.log(monthsList);

  const week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  const options1 = [
    { label: "Week", value: 1 },
    { label: "Month", value: 2 },
    { label: "Year", value: 3 }
  ]

  const option2 = [
    { label: "First", value: 1 },
    { label: "Second", value: 2 },
    { label: "Third", value: 3 },
    { label: "Fourth", value: 4 },
    { label: "Last", value: 5 },
  ]

  const option3 = [
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
    { label: "Sunday", value: 0 },
  ]

  //This is the handleChange for the Year

  const handleMonthChange = (e) => {
    setSelectedMonth(e.value)
  }
  console.log(selectedMonth, "selectedMonth")

  //This is a change event for repeat every and dropdown for (Week,Month and Year)
  const handleOptions = (e) => {
    setRepeatEvery(e)
    setOption(e?.value)
  }


  //Here we are getting the week of the option-2(first,second,third,fourth,last)
  const handleOccurence = (e) => {
    setWeekOfMonth({
      label: e?.label,
      value: e?.value
    })
  }
  console.log("weekOfMonth", (weekOfMonth))

  //Here we are getting the days of the option-2
  const handleDays = (e) => {
    setDaysOfMonth({
      label: e?.label,
      value: e?.value
    })

  }
  console.log(daysOfMonth, "daysOfMonth")

  useEffect(() => {

    if (!isInitialRender) {
      managingMonth()
    } else {
      setIsInitialRender(false);
    }
    // )
  }, [daysOfMonth, weekOfMonth])

  useEffect(() => {
    const currentDate = Moment().format("YYYY-MM-DD");
    const dayString = selectedDate.toString()
    const currentYear = Moment().format('YYYY');
    const currentMonth = Moment().format('MM');
    const fullDate = Moment(`${currentYear}-${currentMonth}-${dayString}`).format('YYYY-MM-DD');
    if (!isInitialRender) {
      if (Date.parse(fullDate) < Date.parse(currentDate)) {
        const fullDate = Moment(`${currentYear}-${Number(Moment().format('MM')) + 1}-${dayString}`).format('YYYY-MM-DD');
        setTodayDate(fullDate)
      } else {
        setTodayDate(fullDate)
      }
    } else {
      setIsInitialRender(false);
    }
  }, [selectedDate])

  useEffect(() => {
    const currentDate = Moment().format("YYYY-MM-DD");
    const dayString = selectYearDate.toString()
    const currentYear = Moment().format('YYYY');
    const currentMonth = Moment().format('MM');
    const fullDate = Moment(`${currentYear}-${currentMonth}-${dayString}`).format('YYYY-MM-DD');
    if (!isInitialRender) {
      if (Date.parse(fullDate) < Date.parse(currentDate)) {
        const fullDate = Moment(`${Number(Moment().format('YYYY'))+1}-${Number(Moment().format('MM'))}-${dayString}`).format('YYYY-MM-DD');
        setTodayDate(fullDate)
      } else {
        setTodayDate(fullDate)
      }
    } else {
      setIsInitialRender(false);
    }
  }, [selectYearDate])
  
  

  // Start Current month all specific days 


  //General function for the start and End of the month


  function findDayDates(year, month, dayOfWeek) {
    console.log(year, month, dayOfWeek, "dayOfWeek123");
    const dates = [];
    const startDate = Moment({ year, month, day: 1 });
    const endDate = Moment(startDate).endOf('month');
    for (let date = startDate; date.isSameOrBefore(endDate); date.add(1, 'day')) {
      if (date.day() === dayOfWeek) {
        dates.push(date.format('YYYY-MM-DD'));
      }
    }
    return dates;
  }

  const currentDate = Moment();
  const year = currentDate.year();
  const month = currentDate.month();
  const dayOfWeek = daysOfMonth.value;
  const dayDates = findDayDates(year, month, dayOfWeek);
  console.log(dayDates, "dayDates111")

  //End

  //Start find next month day dates
  const nextMonth = currentDate.add(1, 'month');
  const Year = nextMonth.year();
  console.log(Year, "year182")
  const Month = nextMonth.month();
  const nextMonthDayDates = findDayDates(Year, Month, dayOfWeek);
  console.log(nextMonthDayDates, "nextMonthDayDates")

  //End of the next month

  //Managing Month

  const managingMonth = () => {
    const currentDate = Moment().format("YYYY-MM-DD");
    if (Date.parse(dayDates[weekOfMonth?.value - 1]) < Date.parse(currentDate)) {
      console.log(nextMonthDayDates[weekOfMonth.value - 1], "1111636 next month")
      setTodayDate(nextMonthDayDates[weekOfMonth.value - 1])
    } else if (Date.parse(dayDates[weekOfMonth?.value - 1]) > Date.parse(currentDate)) {
      setTodayDate(dayDates[weekOfMonth?.value - 1])
    } else {
      setTodayDate(dayDates[weekOfMonth?.value - 1])
    }
  }
  const handleRadioButtonChange = (item) => {
    setSelectedDay(item)

    const getNextDate = () => {
      const currentDate = Moment();
      const targetDay = Moment().isoWeekday(item);

      if (targetDay.isBefore(currentDate)) {
        // If the target day has already passed this week, get the next occurrence next week
        return targetDay.add(1, 'week').format('YYYY-MM-DD');
      }

      return targetDay.format('YYYY-MM-DD');
    }
    setTodayDate(getNextDate())
  }

  console.log("selectedday", selectedDay)

  //This is the handle date change for the option-2

  const handleDateChange = (event) => {
    setSelectedDate(event?.value);
  };
  console.log(selectedDate, "115")
 

  // This is the handle date change for the Year 
  const handleYearDateChange = (event) =>{
    setSelectYearDate(event?.value)
  }


  const renderDateOptions = () => {
    const options = [];
    for (let i = 1; i <= 31; i++) {
      options.push({
        label: i, value: i
      });
    }
    return options;
  };

  //End

  const showOthersOptions = (e) => {
    setRecurring(e?.target.checked)
  }

  //This is the handle change for the start date
  const handleChangeInvoiceDate = (event) => {
    console.log(event.target.value, "startDate")
    const _date = Moment(event?.target?.value).format("YYYY-MM-DD");
    console.log(weekOfMonth, dayDates, "date2");
    setTodayDay(Moment(event?.target?.value).format('dddd'));
    setTodayDate(Moment(event?.target?.value).format('YYYY-MM-DD'));
    setSelectedDay(Moment(event?.target?.value).format('dddd'));
    setDaysOfMonth({
      label: Moment(event?.target?.value).format('dddd'),
      value: Moment(event?.target?.value).format('dddd') == "Monday" ? 1 : Moment(event?.target?.value).format('dddd') == "Tuesday" ? 2 : Moment(event?.target?.value).format('dddd') == "Wednesday" ? 3 : Moment(event?.target?.value).format('dddd') == "Thursday" ? 4 : Moment(event?.target?.value).format('dddd') == "Friday" ? 5 : Moment(event?.target?.value).format('dddd') == "Saturday" ? 6 : 0
    });
    let weekday = Moment(event?.target?.value).format('dddd');
    let weekdayindex = weekday == "Monday" ? 1 : weekday == "Tuesday" ? 2 : weekday == "Wednesday" ? 3 : weekday == "Thursday" ? 4 : weekday == "Friday" ? 5 : weekday == "Saturday" ? 6 : 0;
    console.log("daysOfMonth.value", weekdayindex);
    var a = findDayDates(Moment(event?.target?.value).format("YYYY"), Moment(event?.target?.value).format("MM") - 1, weekdayindex);
    console.log("findDayDates123", a);
    console.log("todayDate", _date)

    //Find The index of the Dates
    var filterIndices = a.reduce((indices, item, index) => {
      if (_date == item) {
        indices.push(index + 1);
      }
      return indices;
    }, []);
    setWeekOfMonth({
      label: filterIndices[0] == 1 ? "First" : filterIndices[0] == 2 ? "Second" : filterIndices[0] == 3 ? "Third" : filterIndices[0] == 4 ? "Fourth" : filterIndices[0] == 5 ? "Last" : "",
      value: filterIndices[0]
    })
    console.log(filterIndices, "filterIndices12455")
  };
  console.log(weekOfMonth, "weekOfMonth")

  //Radio buttons handle Change for the option-2
  const [radioOption, setRadioOption] = useState({})
  const handleRadioChange = (e) => {
    setRadioOption(e.target.value)
    if (radioOption === "radioDates") {
      const currentDate = Moment().format("YYYY-MM-DD");
      const dayString = selectedDate.toString()
      const currentYear = Moment().format('YYYY');
      const currentMonth = Moment().format('MM');
      let fullDate = Moment(`${currentYear}-${currentMonth}-${dayString}`).format('YYYY-MM-DD');
      if (Date.parse(fullDate) < Date.parse(currentDate)) {
        console.log(Number(Moment().format('MM')) + 1, "month270")
        fullDate = Moment(`${currentYear}-${Number(Moment().format('MM')) + 1}-${dayString}`).format('YYYY-MM-DD');
      }
      setTodayDate(fullDate)
    } else if (radioOption === "radioDay") {
      managingMonth()
    }
  }

  // Year Calculation

  // const calculateDate = (selectedDate, selectedMonth) => {

  //   // console.log(selectedDate, "456 jadugar")
  //   // console.log(selectedMonth, "456 jadugar")

  //   // Get the current date
  //   const currentDate = Moment();

  //   // Create a new moment object with the selected date and month
  //   const targetDate = Moment()
  //     .year(currentDate.year()) // Set the year to the current year
  //     .month(selectedMonth - 1) // Month is zero-based, so subtract 1
  //     .date(selectedDate);

  //   // If the target date is before the current date, add a year
  //   if (targetDate.isBefore(currentDate)) {
  //     targetDate.add(1, 'year');
  //   }

  //   // Format the final date in the desired format (e.g., 'YYYY-MM-DD')
  //   const formattedDate = targetDate.format('YYYY-MM-DD');
  //   return formattedDate;
  // }

  // useEffect(() => {
  //   setTodayDate(calculateDate(selectedMonth))
  // }, [selectedMonth])  


  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title">Manage Task</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/giftcard">Add Task</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Add Task</h5>
            </div>
            <Formik
              // initialValues={formValues}
              // validationSchema={validationSchema}
              // onSubmit={handleSubmit}
              // enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-2 form-label">
                            Task Name
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.GiftcardNumber ? "is-invalid" : ""
                                }`}
                              // onChange={handleChange}
                              id="taskName"
                              name="taskName"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <div className="col-lg-8">
                            <div className="d-flex mt-3 mb-2">
                              <label class="form-check-label" style={{ paddingRight: "0.5rem" }} for="flexSwitchCheckDefault">Recurring task</label>
                              <div class="form-check form-switch col-md-1">
                                <input class="form-check-input m-auto mt-1" name="section3" type="checkbox" role="switch" onChange={showOthersOptions} id="flexSwitchCheckDefault" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      recurring &&
                      <>
                        <div style={{ width: "90%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
                          <div style={{ width: "20%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>Start:</span>
                            <input
                              type="date"
                              className="form-control form-control w-75"
                              id="StartDate"
                              name="StartDate"
                              value={todayDate}
                              onChange={(event) => handleChangeInvoiceDate(event)}
                            />
                          </div>
                          <div style={{ width: "20%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label>
                              Repeat Every<span className="text-danger">*</span>
                            </label>
                            <Field
                              type="number"
                              className="form-control w-50"
                              id="repeat"
                              name="repeat"
                            />
                          </div>

                          <div>
                            <Select
                              defaultValue={repeatEvery}
                              options={options1}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              isClearable={true}
                              onChange={(e) => handleOptions(e)}
                            />
                          </div>
                          <div style={{ width: "20%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>End:</span>
                            <input
                              type="date"
                              className="form-control form-control w-75"
                              id="StartDate"
                              name="StartDate"
                              // value={todayDay}
                              defaultValue={todayDay}
                            // onChange={(event) => handleChangeInvoiceDate(event)}
                            />
                          </div>
                          <div>
                            <input type='radio' />
                            Never Ends
                          </div>
                        </div>
                        {
                          (option == 1) ? (
                            <div style={{ width: "60%", display: "flex", justifyContent: "space-between", marginTop: "40px", marginBottom: "40px" }}>
                              {
                                week?.map((item) => {
                                  return (
                                    <div style={{ width: "10%", display: "flex", justifyContent: "space-evenly" }}>
                                      <input type='radio' checked={selectedDay === item} onChange={() => handleRadioButtonChange(item)} />
                                      <label style={{ fontSize: "16px" }} >{item}</label>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          ) : (option == 2) ? (
                            <div style={{ width: "50%", display: "flex", justifyContent: "space-between" }}>
                              <input
                                type="radio"
                                name="day"
                                value="radioDay"
                                onChange={handleRadioChange}
                              />
                              <div style={{ width: "17%", marginBottom: "20px", marginTop: "10px" }}>
                                <Select
                                  value={renderDateOptions().find((el) => el.value == selectedDate)}
                                  options={renderDateOptions()}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  isClearable={true}
                                  onChange={radioOption === "radioDay" && handleDateChange}
                                />
                              </div>
                              <input
                                type="radio"
                                name="day"
                                value="radioDates"
                                onChange={handleRadioChange}
                              />
                              <div style={{ width: "25%", marginBottom: "20px", marginTop: "10px" }}>
                                <Select
                                  value={option2.find((el)=>el.value===weekOfMonth)}
                                  options={radioOption === "radioDates" && option2}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  isClearable={true}
                                  onChange={radioOption === "radioDates" && handleOccurence}
                                />
                              </div>
                              <div style={{ width: "27%", marginBottom: "20px", marginTop: "10px" }}>
                                <Select
                                  value={option3.find((el)=>el.value===daysOfMonth)}
                                  // value={daysOfMonth}
                                  options={radioOption === "radioDates" && option3}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  isClearable={true}
                                  onChange={radioOption === "radioDates" && handleDays}
                                />
                              </div>
                            </div>
                          ) : (option == 3) ? (
                            <div 
                              style={{ 
                              width: "30%", 
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "20px", 
                              marginTop: "20px" 
                              }}
                              >
                              <div>
                                <Select
                                  defaultValue="Select a Date"
                                  options={renderDateOptions()}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  isClearable={true}
                                  onChange={handleYearDateChange}
                                />
                              </div>
                              <div>
                                <Select
                                  // defaultValue="Select a Date"
                                  value={monthsDropdown.find((el) =>
                                    el.value == selectedMonth
                                  )}
                                  options={monthsDropdown}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  isClearable={true}
                                  onChange={handleMonthChange}
                                />
                              </div>
                            </div>
                          ) : ""
                        }
                      </>
                    }
                    <div>
                      <div style={{ width: "60%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ width: "45%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <label>
                            Assigned To <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control"
                              id="AssignedTo"
                              name="AssignedTo"
                            />
                          </div>
                        </div>
                        <div style={{ width: "25%", display: "flex", }}>
                          <span>Due Date:</span>
                          <input
                            type="date"
                            className="form-control"
                            id="DueDate"
                      
                            name="DueDate"
                            // value={todayDate}
                            defaultValue={todayDay}
                          // onChange={(event) => handleChangeInvoiceDate(event)}
                          />
                        </div>
                      </div>
                      <div className="col-md-10">
                        <div className="form-group row">
                          <label className="col-form-label col-md-12 form-label">
                            Notes
                          </label>
                          <div className="col-lg-8">
                            <textarea
                              type="text"
                              placeholder='Add extra info related to this task'
                              className="form-control"
                              col={12}
                              row={12}
                              // onChange={handleChange}
                              id="Notes"
                              name="Notes"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                    <Link
                      to="/task"
                      className="btn btn-dark btn-md me-1 pull-right"
                    >
                      Cancel
                    </Link>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div >
    </>
  )
}

export default ManageTask;